import { gql } from "@apollo/client";

export const SET_MEMBER_PERMISSIONS = gql`
  mutation setMemberPermissions(
    $input: SetSkynetUserGroupMemberPermissionsInput!
  ) {
    rolesAndPermissions {
      setMemberPermissions(input: $input) {
        success
      }
    }
  }
`;
